/*
 * Custom behaviour for Billige Hjælpemidler (moved from layout/theme.liquid).
 * - Terms popup before checkout (cart page and cart drawer)
 * - Video modals ([data-video-target] / [data-video-close])
 * - Header search: empty search opens predictive search instead of submitting
 * - <campaign-countdown>, <custom-carousel>
 */

/* ---------- Terms popup before checkout ---------- */

const termsPopup = document.querySelector('[data-terms-popup]');

const openTermsPopup = () => {
  termsPopup.classList.add('is-open');
  termsPopup.setAttribute('aria-hidden', 'false');
};

const closeTermsPopup = () => {
  termsPopup.classList.remove('is-open');
  termsPopup.setAttribute('aria-hidden', 'true');
};

if (termsPopup) {
  setTimeout(() => termsPopup.classList.add('loaded'), 400);

  document.body.addEventListener('click', (event) => {
    const target = event.target;

    if (target.closest('[data-close]')) closeTermsPopup();

    if (target.closest('[data-accept]')) {
      closeTermsPopup();
      const terms = document.querySelector('[data-terms]');
      if (terms) {
        terms.checked = true;
        const submit = terms.closest('form').querySelector('[type="button"][name="checkout"]');
        submit.type = 'submit';
        submit.click();
      }
    }

    const drawerCheckout = document.querySelector('.cart-drawer__footer')?.closest('form')?.querySelector('[type="button"][name="checkout"]');
    if (drawerCheckout && target === drawerCheckout) {
      if (document.querySelector('#acceptTerms')?.checked) {
        drawerCheckout.type = 'submit';
        drawerCheckout.click();
      } else {
        openTermsPopup();
      }
    }
  });
}

/* ---------- Video modals ---------- */

const openVideoModal = (modal) => {
  modal.hidden = false;
  document.body.classList.add('videoPoup_open');
  const video = modal.querySelector('video');
  if (video) {
    video.muted = false;
    video.currentTime = 0;
    requestAnimationFrame(() => video.play().catch(() => {}));
  }
};

const closeVideoModal = (modal) => {
  const video = modal.querySelector('video');
  if (video) {
    video.pause();
    video.muted = true;
  }
  modal.hidden = true;
  document.body.classList.remove('videoPoup_open');
};

document.body.addEventListener('click', (event) => {
  const playButton = event.target.closest('[data-video-target]');
  if (playButton) {
    const modal = document.querySelector(playButton.getAttribute('data-video-target'));
    if (modal) openVideoModal(modal);
    return;
  }

  const closeButton = event.target.closest('[data-video-close]');
  if (closeButton) {
    closeVideoModal(closeButton.closest('.video_popup'));
    return;
  }

  if (event.target.classList.contains('video_popup')) closeVideoModal(event.target);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openModal = document.querySelector('.video_popup:not([hidden])');
  if (openModal) closeVideoModal(openModal);
});

/* ---------- Header search ---------- */

const headerSearchForm = document.querySelector('#predictive-search-form');

if (headerSearchForm) {
  const headerSearchInput = document.querySelector('#header-search__input');
  const searchButton = headerSearchForm.querySelector('.header-search-button');

  const handleEmptySearch = (event) => {
    if (headerSearchInput.value.trim() !== '') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    headerSearchInput.focus();
    headerSearchInput.click();
  };

  headerSearchForm.addEventListener('submit', handleEmptySearch, true);
  searchButton.addEventListener('click', handleEmptySearch, true);
}

/* ---------- Campaign countdown ---------- */

class CampaignCountdown extends HTMLElement {
  connectedCallback() {
    this.end = new Date(this.dataset.end).getTime();
    if (Number.isNaN(this.end)) throw new Error(`campaign-countdown: invalid date "${this.dataset.end}"`);

    this.values = Object.fromEntries(
      [...this.querySelectorAll('[data-unit]')].map((element) => [element.dataset.unit, element])
    );
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));

    if (remaining === 0) {
      clearInterval(this.interval);
      this.closest('[data-campaign]').hidden = true;
      return;
    }

    const parts = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };

    Object.entries(parts).forEach(([unit, value]) => {
      this.values[unit].textContent = String(value).padStart(2, '0');
    });
  }
}

/* ---------- Carousel (reviews) ---------- */

class CustomCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prev = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');
    this.prev.addEventListener('click', () => this.scroll(-1));
    this.next.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
    this.updateButtons();
  }

  scroll(direction) {
    this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
  }

  updateButtons() {
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    this.prev.disabled = this.track.scrollLeft <= 2;
    this.next.disabled = this.track.scrollLeft >= max;
    this.classList.toggle('is-scrollable', max > 0);
  }
}

customElements.define('campaign-countdown', CampaignCountdown);
customElements.define('custom-carousel', CustomCarousel);
